import {Component, Input, OnInit} from '@angular/core';
import {ISpacing} from '@app/feature/store-editor/components/layout/store-editor.interface';


@Component({
  selector: 'app-spacing-setting',
  templateUrl: './spacing-setting.component.html',
  styleUrls: ['./spacing-setting.component.css']
})
export class SpacingSettingComponent implements OnInit {

  @Input() spacing: ISpacing ;

  constructor() {
  }

  ngOnInit() {
  }

}
